import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';

import IntroStep1 from '../organisms/IntroStep1';
import IntroButton from '../molecules/IntroButton';

// import IntroStep from '../organisms/IntroStep';
// import Img1 from '../assets/images/timeline_1.jpg';
// import Img2 from '../assets/images/timeline_2.jpg';
// import Img3 from '../assets/images/timeline_3.jpg';

class Intro extends Component {

  constructor( props ) {
    super( props );
    this.state = {
      currentStep: 1,
    }
  }

  handleProgressClick = () => {
    this.setState( {
      currentStep: this.state.currentStep + 1,
    } );
  };

  handleCloseClick = () => {
    this.setState( {
      currentStep: 0,
    } );
    this.props.dispatch( {
      type: 'HIDE_INTRO',
    } );
  };

  render() {
    return (
      <CSSTransition
        in={this.props.showIntro}
        unmountOnExit
        classNames="Intro"
        timeout={1000}>
        <div className="Intro">
          <IntroStep1 show={this.state.currentStep === 1} timeout={2500}/>
          <p className="buttonHolder">
            <IntroButton
              step={this.state.currentStep}
              handleProgressClick={this.handleProgressClick}
              handleCloseClick={this.handleCloseClick}/>
          </p>
        </div>
      </CSSTransition>
    )
  }
}

function mapStateToProps( state ) {
  return {
    showIntro: state.showIntro.showIntro,
  };
}

export default connect( mapStateToProps )( Intro );
